<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    DAFTAR PASIEN IGD
                </h1>
            </div>
            <div class="w-full md:w-1/2 mt-5 mx-auto">
                <SelectInput
                            v-model="statusData"
                            id="status"
                            label="STATUS"
                        >
                            <option value="">=== PILIH STATUS ===</option>
                            <option value="all">Semua</option>
                            <option value="active">Aktif</option>
                            <option value="out">Keluar</option>
                            <option value="void">Void</option>
                </SelectInput>
            </div>
            <div class="w-full md:w-1/2 mt-5 mb-5 mx-auto">
                <DateInput
                    v-model="tglMasukAwalData"
                    class="w-full grow mr-5"
                    id="tgl_masuk"
                    label="PILIH TANGGAL MASUK AWAL"
                />
            </div>
            <div class="w-full md:w-1/2 mt-5 mb-5 mx-auto">
                <DateInput
                    v-model="tglMasukAkhirData"
                    class="w-full grow mr-5"
                    id="tgl_masuk_akhir"
                    label="PILIH TANGGAL MASUK AKHIR"
                />
            </div>
            <div class="w-full flex md:w-1/2 mx-auto">
                <button
                    @click.prevent="exportExcel()"
                    class="bg-pink-600 hover:bg-pink-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center ml-auto self-end w-36 h-10 text-xs mr-2"
                >
                    EXPORT EXCEL
                </button>
                <button
                    @click.prevent="getPasienIgd()"
                    class="bg-green-600 hover:bg-green-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center w-36 h-10 text-xs"
                >
                    CARI
                </button>
            </div>
            <div class="w-full my-3">
                <div class="font-poppins mt-2 mb-2 text-right">
                    <p class="font-sm font-bold uppercase">
                        TOTAL PASIEN IGD AKTIF: {{ pasienIgdData.pasienIgdAktif }}
                    </p>
                </div>
                <div class="font-poppins mt-2 mb-2 text-right">
                    <p class="font-sm">
                        data diperbaharui pada :
                        <span class="text-red-500"
                            >{{ timerCount }} (10 Menit)</span
                        >
                    </p>
                </div>
                <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300 mb-8">
                <table class="w-full whitespace-nowrap">
                    <thead>
                        <tr class="text-left font-bold bg-amber-100">
                            <th class="py-2 px-3 text-center text-sm">No</th>
                            <th class="py-2 px-3 text-center text-sm">Register</th>
                            <th class="py-2 px-3 text-center text-sm">Tanggal Masuk</th>
                            <th class="py-2 px-3 text-center text-sm">Jam Masuk</th>
                            <th class="py-2 px-3 text-center text-sm">No.RM</th>
                            <th class="py-2 px-3 text-center text-sm">Nama</th>
                            <th class="py-2 px-3 text-center text-sm">Dokter</th>
                            <th class="py-2 px-3 text-center text-sm">
                                Waktu Tunggu
                            </th>
                            <th class="py-2 px-3 text-center text-sm">
                                Jam Reg Keluar
                            </th>
                            <th class="py-2 px-3 text-center text-sm">
                                Tgl Reg Keluar
                            </th>
                            <th class="py-2 px-3 text-center text-sm">
                                Register Inap
                            </th>
                            <th class="py-2 px-3 text-center text-sm">Bangsal</th>
                            <th class="py-2 px-3 text-center text-sm">
                                Cara Keluar
                            </th>
                            <th class="py-2 px-3 text-center text-sm">
                                Jam Reg Inap
                            </th>
                            <th class="py-2 px-3 text-center text-sm">
                                Tgl Reg Inap
                            </th>
                            <th class="py-2 px-3 text-center text-sm">
                                Register
                            </th>
                            <th class="py-2 px-3 text-center text-sm">
                                DPJP Inap
                            </th>
                            <th class="py-2 px-3 text-center text-sm">
                                Keadaan Keluar IGD
                            </th>
                            <th class="py-2 px-3 text-center text-sm">
                                Cara Masuk IGD
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="pasienIgd in pasienIgdData.pasien"
                            class="hover:bg-gray-100"
                        >
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.no }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.register }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.tanggal }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.jam }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.no_rm }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.nama }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.dokter }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer"></td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ (pasienIgd.jam_reg_keluar==="00:00:00")?'': pasienIgd.jam_reg_keluar}}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ (pasienIgd.tgl_reg_keluar==="3000-01-01")?'':pasienIgd.tgl_reg_keluar }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.register_inap }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.bangsal }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.cara_keluar }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.jam_reg_inap }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.tgl_reg_inap }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.status_registrasi }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.dpjp_inap }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.keadaan_keluar }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                {{ pasienIgd.cara_masuk }}
                            </td>
                        </tr>
                        <tr class="bg-white hover:bg-gray-100 focus-within:bg-gray-100" v-if="pasienIgdData.length === 0">
                            <td class="border-r border-t text-sm select-none cursor-pointer" colspan="19">
                                Belum ada data pasien igd
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdminBig from "../../../Shared/LayoutAdminBig.vue";
import RandomShape from "../../../Shared/RandomShape.vue";
import DateInput from "../../../Shared/DateInput.vue";
import TextInput from "../../../Shared/TextInput.vue";
import SelectInput from "../../../Shared/SelectInput.vue";
export default {
    components: {
        Link,
        RandomShape,
        DateInput,
        TextInput,
        SelectInput
    },
    data() {
        return {
            tglMasukAwalData: this.tglMasukAwal,
            tglMasukAkhirData: this.tglMasukAkhir,
            statusData: this.status,
            pasienIgdData: this.pasienIgd,
            timerCount: 600,
        };
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                } else {
                    this.getPasienIgd();
                }
            },
            immediate: true,
        },
    },
    props: {
        tglMasukAwal: String,
        tglMasukAkhir: String,
        status: String,
        pasienIgd: Object,
    },
    methods: {
        getPasienIgd() {
            this.$inertia.get(
                "/admin/pasien_igd/ajax",
                {
                    tglMasukAwal: this.tglMasukAwalData,
                    tglMasukAkhir: this.tglMasukAkhirData,
                    status: this.statusData
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.timerCount = 600;
                        this.pasienIgdData = page.props.additional.pasienIgd;
                    },
                }
            );
        },
        exportExcel(){
            location.href = '/admin/pasien_igd/export/excel?tglMasukAwal='+this.tglMasukAwalData+'&tglMasukAkhir='+this.tglMasukAkhirData+'&status='+this.statusData;
        }
    },
    layout: LayoutAdminBig,
};
</script>
